export const blockIconsAlertAutoDelete = (
	<span className='material-symbols-outlined'>auto_delete</span>
);
